/* @flow */

import React from 'react'

import BlogRoll from '../../../components/BlogRoll'
import Hero from '../../../components/Hero/index'

export default () => (
  <section>
    <BlogRoll small={false} />
  </section>
)
